export enum SCREEN_TYPES {
  WINDOW = 1320,
  TABLETTE = 913,
  MOBILE = 343,
}

export enum PERMITER_SEARCH_MODE {
  SEARCH_ENABLED = 'search-enabled',
  SEARCH_DISABLED = 'search-disabled',
}

export enum PERIMETER_MODE {
  INCREASED_MODE = 'increased-mode',
  DECREASED_MODE = 'decreased-mode',
}
